import React from 'react';
import { OpeningScreen } from '../screens/OpeningScreen';
import { ResponseScreen } from '../screens/ResponseScreen';
import { TransitionScreen } from '../screens/TransitionScreen';
import { FamilyScreen } from '../screens/FamilyScreen';
import { ProductScreen } from '../screens/ProductScreen';
import { PointScreen } from '../screens/PointScreen';
import { CloseScreen } from '../screens/CloseScreen';
import { SnakCtaGrid } from './SnakCtaGrid';
import { POINT_STEP, PRODUCT_START } from '../../utils/snakSteps';
import type { FilteknProduct, SiblingRole } from '../../types/snak';
interface SnakStepViewProps {
  step: number;
  order: FilteknProduct[];
  role: SiblingRole | null;
  autoplayInterlude: boolean;
  onSelect: (role: SiblingRole) => void;
  onNext: () => void;
  onRestart: () => void;
  onDarken: (dark: boolean) => void;
}

/**
 * Maps a step to its screen. Shared by the live Snak and the storyboard.
 * Every Solventum-styled screen (the family portrait onwards) ends with the
 * four calls to action.
 */
export function SnakStepView(props: SnakStepViewProps) {
  const screen = <StepScreen {...props} data-id="element-493" data-mp="2iesi9b3wny1u" />;
  if (props.step < FAMILY_STEP) return screen;
  return <div className="flex flex-1 flex-col" data-id="element-494" data-mp="2icprupyuc2wl">
      {screen}
      <SnakCtaGrid data-id="element-495" data-mp="2w4ma82apiyfs" />
    </div>;
}
const FAMILY_STEP = 3;
function StepScreen({
  step,
  order,
  role,
  autoplayInterlude,
  onSelect,
  onNext,
  onRestart,
  onDarken
}: SnakStepViewProps) {
  if (step === 0) return <OpeningScreen selected={role} onSelect={onSelect} data-id="element-496" data-mp="23hjl20rx8027" />;
  if (step === 1) return <ResponseScreen role={role ?? 'firstborn'} onNext={onNext} data-id="element-497" data-mp="1zgzoayb9eygl" />;
  if (step === 2) {
    return <TransitionScreen autoplay={autoplayInterlude} onDarken={onDarken} onNext={onNext} data-id="element-498" data-mp="2dg8ynhcsaycn" />;
  }
  if (step === FAMILY_STEP) return <FamilyScreen onNext={onNext} data-id="element-499" data-mp="3ou38hgl0d9jx" />;
  if (step < POINT_STEP) {
    const product = order[step - PRODUCT_START];
    if (!product) return null;
    return <ProductScreen product={product} position={step - PRODUCT_START + 1} total={order.length} onNext={onNext} data-id="element-500" data-mp="3jv9vdp9mvkka" />;
  }
  if (step === POINT_STEP) return <PointScreen onNext={onNext} data-id="element-501" data-mp="3vw86395cnoxd" />;
  return <CloseScreen onRestart={onRestart} data-id="element-502" data-mp="4ri0r5ye4d5h" />;
}